import React, { useState } from 'react';
import { SparklesIcon } from 'lucide-react';
import { genreColors, formatIcons } from './constants';
import { BookHoverCard } from './BookHoverCard';
import { VendorBookInfoModal, CoverCarousel } from './BookDisplay';
export const SeriesBooksView = ({
  seriesData,
  viewMode,
  darkMode,
  hoveredBookId,
  setHoveredBookId,
  mousePosition,
  navigateToBookEdit
}: any) => {
  const [selectedBook, setSelectedBook] = useState<any | null>(null);
  const isMobile = typeof window !== 'undefined' && window.innerWidth < 768;
  const handleSpineTap = (book: any) => {
    if (window.innerWidth < 768) {
      setSelectedBook(book);
    } else {
      navigateToBookEdit(book.id);
    }
  };
  return <>
      {Object.entries(seriesData as Record<string, any[]>).map(([seriesName, books]) => <div key={seriesName} className={`${darkMode ? 'bg-gray-800' : 'bg-white'} rounded-lg shadow-md p-6 mb-8`} data-id="element-18186" data-mp="3qnru2mm9658a">
            <h2 className={`text-xl font-semibold mb-6 ${darkMode ? 'text-white' : 'text-gray-900'}`} data-id="element-18187" data-mp="2ww7iw0v322f2">
              {seriesName}
            </h2>

            {viewMode === 'spine' ? <div className="relative" data-id="element-18188" data-mp="2nw2c9sxpr81y">
                <div className="flex items-end gap-2 overflow-x-auto pb-6 scrollbar-thin" style={{
          minHeight: 260
        }} data-id="element-18189" data-mp="2nv101l4yofin">
                  {books.map((book: any) => <div key={book.id} onClick={() => handleSpineTap(book)} onMouseEnter={() => !isMobile && setHoveredBookId(book.id)} onMouseLeave={() => setHoveredBookId(null)} className="relative flex flex-col items-center justify-center text-white font-medium rounded transition-transform duration-200 ease-in-out cursor-pointer text-center hover:scale-105 select-none flex-shrink-0" style={{
            width: book.edition === 'special' ? 68 : 56,
            height: book.edition === 'special' ? 250 : 220,
            fontSize: book.edition === 'special' ? '1rem' : '0.85rem',
            backgroundColor: genreColors[!book.coverImage ? book.genre : ''] || genreColors.default,
            backgroundImage: book.coverImage ? `url(${book.coverImage})` : undefined,
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            marginBottom: 4
          }} title={book.title} data-id="element-18190" data-mp="2iwzij4n6oo9a">
                      {!book.coverImage && <div className="flex flex-col items-center px-1 w-full h-full justify-center" style={{
              writingMode: 'vertical-rl'
            }} data-id="element-18191" data-mp="2ve0gbhx4lqxs">
                          <div className="w-full truncate" data-id="element-18192" data-mp="2v8rhblplamlu">{book.title}</div>
                          {book.seriesNumber && <div className="mt-2 text-xs font-normal opacity-80" data-id="element-18193" data-mp="300t1ruwwvjmy">
                              #{book.seriesNumber}
                            </div>}
                        </div>}
                      <div className="absolute bottom-1 left-1 inline-flex items-center justify-center p-1 rounded bg-black bg-opacity-70 text-white text-xs z-10" title={book.format} data-id="element-18194" data-mp="392iowojrfwex">
                        {formatIcons[book.format]}
                      </div>
                      {book.edition === 'special' && <div className="absolute top-1 right-1 inline-flex items-center justify-center p-1 rounded-full bg-purple-600 bg-opacity-90 text-white text-xs z-10" data-id="element-18195" data-mp="1omp8ys2281jh">
                          <SparklesIcon className="h-3 w-3" data-id="element-18196" data-mp="3a2d5qo4zuvcz" />
                        </div>}
                    </div>)}
                  <div className={`absolute bottom-0 left-0 right-0 h-2 ${darkMode ? 'bg-purple-900' : 'bg-purple-600'} rounded-full`} data-id="element-18197" data-mp="3j31p7yd5pnx9" />
                </div>
                {/* Hover card — desktop only */}
                {!isMobile && hoveredBookId && books.some((book: any) => book.id === hoveredBookId) && (() => {
          const hoveredBook = books.find((book: any) => book.id === hoveredBookId);
          return hoveredBook ? <BookHoverCard book={hoveredBook} darkMode={darkMode} mousePosition={mousePosition} data-id="element-18198" data-mp="27oxv8s6kjzs7" /> : null;
        })()}
              </div> /* Cover view — carousel for ordered series */ : <CoverCarousel books={books} darkMode={darkMode} onBookClick={book => setSelectedBook(book)} onHoverEnter={id => !isMobile && setHoveredBookId(id)} onHoverLeave={() => setHoveredBookId(null)} data-id="element-18199" data-mp="e78ms3gn857l" />}
          </div>)}

      {selectedBook && <VendorBookInfoModal book={selectedBook} darkMode={darkMode} onClose={() => setSelectedBook(null)} onEdit={navigateToBookEdit} data-id="element-18200" data-mp="wv3t529xegqo" />}
    </>;
};